/*
  POS Search Resource Router
  --------------------------
  Scope: search forms only.

  This script DOES NOT:
  - redirect the browser
  - call fetch/XHR
  - touch cookies/localStorage/sessionStorage
  - touch dataLayer, gtag, Meta Pixel, Clarity, analytics, or trackers
  - prevent the normal form submission

  It only adds/updates the Shopify `type` field immediately before a
  normal search form submits:
    exact policy/help intent -> page
    everything else         -> product
*/
(function () {
  'use strict';

  var PAGE_TERMS = [
    'return',
    'returns',
    'return policy',
    'returns policy',
    'refund',
    'refunds',
    'refund policy',
    'refunds policy',
    'replacement',
    'replacement policy',
    'return refund and replacement policy',
    'return refund replacement policy',
    'returns and cancellation policy',
    'return and cancellation policy',
    'cancellation policy',

    'privacy',
    'privacy policy',

    'shipping',
    'shipping policy',
    'delivery policy',
    'shipping and delivery policy',

    'terms and conditions',
    'terms & conditions',
    'terms of service',

    'contact us',
    'contact page'
  ];

  function normalizeSearchTerm(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getResourceType(term) {
    return PAGE_TERMS.indexOf(normalizeSearchTerm(term)) !== -1
      ? 'page'
      : 'product';
  }

  function isSearchForm(form) {
    if (!form || form.tagName !== 'FORM') return false;

    var queryInput = form.querySelector('input[name="q"]');
    if (!queryInput) return false;

    try {
      var action = new URL(form.getAttribute('action') || window.location.href, window.location.origin);
      return action.pathname === '/search' || action.pathname.endsWith('/search');
    } catch (error) {
      return false;
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (!isSearchForm(form)) return;

      var queryInput = form.querySelector('input[name="q"]');
      var typeInput = form.querySelector('input[name="type"]');

      if (!typeInput) {
        typeInput = document.createElement('input');
        typeInput.type = 'hidden';
        typeInput.name = 'type';
        form.appendChild(typeInput);
      }

      typeInput.value = getResourceType(queryInput.value);
    },
    true
  );
})();
